module.exports = __webpack_public_path__ + "images/emoji/no_mouth.a5e1ed327c3d9ad85102.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/no_mouth.png
// module id = krAe
// module chunks = 1